export default __webpack_public_path__ + "static/media/image-1.c223fd9b.jpeg";